const originalError = console.error;

console.error = (...arg) => {
  if (
    arg[0]?.includes?.(
      'Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.'
    ) ||
    arg[0]?.includes?.(
      'uses the legacy contextTypes API which is no longer supported and will be removed in the next major release.'
    ) ||
    arg[0]?.includes?.('has been renamed, and is not recommended for use') ||
    arg[0]?.includes?.('findDOMNode is deprecated and will be removed in the next major release') ||
    arg[0]?.includes?.(
      'uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release'
    )
  ) {
    return;
  }
  originalError(...arg);
};
